/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  UpsertAiScanTargetRequestBody,
  UpsertAiScanTargetRequestBody$Outbound,
  UpsertAiScanTargetRequestBody$outboundSchema,
} from "../components/upsertaiscantargetrequestbody.js";

export type UpsertAiScanTargetSecurity = {
  sessionHeaderGramSession?: string | undefined;
};

export type UpsertAiScanTargetRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  upsertAiScanTargetRequestBody: UpsertAiScanTargetRequestBody;
};

/** @internal */
export type UpsertAiScanTargetSecurity$Outbound = {
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const UpsertAiScanTargetSecurity$outboundSchema: z.ZodMiniType<
  UpsertAiScanTargetSecurity$Outbound,
  UpsertAiScanTargetSecurity
> = z.pipe(
  z.object({
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function upsertAiScanTargetSecurityToJSON(
  upsertAiScanTargetSecurity: UpsertAiScanTargetSecurity,
): string {
  return JSON.stringify(
    UpsertAiScanTargetSecurity$outboundSchema.parse(upsertAiScanTargetSecurity),
  );
}

/** @internal */
export type UpsertAiScanTargetRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  UpsertAiScanTargetRequestBody: UpsertAiScanTargetRequestBody$Outbound;
};

/** @internal */
export const UpsertAiScanTargetRequest$outboundSchema: z.ZodMiniType<
  UpsertAiScanTargetRequest$Outbound,
  UpsertAiScanTargetRequest
> = z.pipe(
  z.object({
    gramSession: z.optional(z.string()),
    upsertAiScanTargetRequestBody: UpsertAiScanTargetRequestBody$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      upsertAiScanTargetRequestBody: "UpsertAiScanTargetRequestBody",
    });
  }),
);

export function upsertAiScanTargetRequestToJSON(
  upsertAiScanTargetRequest: UpsertAiScanTargetRequest,
): string {
  return JSON.stringify(
    UpsertAiScanTargetRequest$outboundSchema.parse(upsertAiScanTargetRequest),
  );
}
